import { render, staticRenderFns } from "./GridElement.vue?vue&type=template&id=5b007abe"
import script from "./GridElement.vue?vue&type=script&lang=js"
export * from "./GridElement.vue?vue&type=script&lang=js"
import style0 from "./GridElement.vue?vue&type=style&index=0&id=5b007abe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports